import { type FC, useState } from 'react';

import GlobalSearchInput, { type GlobalSearchInputProps } from './GlobalSearchInput';
import GlobalSearchResults, { type GlobalSearchResultsProps } from './GlobalSearchResults';

export type GlobalSearchProps = GlobalSearchInputProps & GlobalSearchResultsProps;

const GlobalSearch: FC<GlobalSearchProps> = ({
  data,
  isLoading,
  onClear,
  onSubmit,
  placeholder,
}) => {
  const [formElement, setFormElement] = useState<HTMLFormElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleFocus = () => {
    if (data !== null) {
      setIsOpen(true);
    }
  };

  const handleSubmit = (searchValue: string) => {
    setIsOpen(true);

    onSubmit(searchValue);
  };

  return (
    <>
      <GlobalSearchInput
        isLoading={isLoading}
        onClear={onClear}
        onFocus={handleFocus}
        onSubmit={handleSubmit}
        placeholder={placeholder}
        ref={setFormElement}
      />

      <GlobalSearchResults
        data={data}
        formElement={formElement}
        isOpen={isOpen}
        onClose={handleClose}
      />
    </>
  );
};

export default GlobalSearch;
